import React from 'react';
import { connect } from 'react-redux';
import properties from '../../../constants/Properties';
import locales from '../../../locales/LocalesManager';
import mouseUtils from '../../utils/MouseUtils';
import {
    showTrackMenu,
    changeSolo,
    changeMute,
    addTrack,
    deleteTrack,
    refreshAudioTrack
} from '../../../actions/AudioEditorActions';
import { setButtonsHolderWidth, showDeleteTrackAlert } from '../../../actions/MenuActions';
import storeManager from '../../../store/StoreManager';
import audioEditorUtils from '../utils/AudioEditorUtils';
import audioToolUtils from '../../audioTool/utils/AudioToolUtils';
import saveManager from '../../utils/SaveManager';
import platformDetection from '../../utils/PlatformDetection';
import textSizeUtils from '../../utils/TextSizeUtils';

const Button = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    getTimeline(index) {
        const state = storeManager.getState();
        const timelines = state.audioEditor.timelines;

        return timelines[index];
    },
    isEmptyTrack(trackIndex) {
        const state = storeManager.getState();
        const timelines = state.audioEditor.timelines;
        const audios = timelines[trackIndex].audios;

        if (audios && audios.length > 0)
            return false;
        else
            return true;
    },
    onTouchStart() {
        if (this.props.index == 0) {
            const buttonsHolderWidth = storeManager.getState().menu.buttonsHolderWidth;
            const isCollapsedDefault = platformDetection.isIOS() && !buttonsHolderWidth;

            if (isCollapsedDefault || buttonsHolderWidth == properties.BUTTONS_HOLDER_COLLAPSED_WIDTH) {
                this.props.dispatch(setButtonsHolderWidth(properties.BUTTONS_HOLDER_WIDTH));
                audioEditorUtils.checkTimelineWidth(false, -1, true);
            }
        }
    },
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        audioEditorUtils.currentTrackMenu = this.props.trackIndex;
        saveManager.isContentChanged(true);

        if (this.isDisabled())
            return;

        switch(this.props.index) {
            case 0: {
                this.setTitleFocus();
                break;
            }
            case 1: {
                this.props.dispatch(changeSolo(this.props.trackIndex));
                this.props.dispatch(refreshAudioTrack(Math.random()));
                saveManager.isContentChanged(true);
                break;
            }
            case 2: {
                this.props.dispatch(changeMute(this.props.trackIndex));
                this.props.dispatch(refreshAudioTrack(Math.random()));
                saveManager.isContentChanged(true);
                break;
            }
            case 3: {
                this.props.dispatch(addTrack(this.props.trackIndex));
                saveManager.isContentChanged(true);
                break;
            }
            case 4: {

                if (this.isEmptyTrack(this.props.trackIndex)) {
                    this.props.dispatch(deleteTrack(this.props.trackIndex));
                    saveManager.isContentChanged(true);
                } else
                    this.props.dispatch(showDeleteTrackAlert(true));
                break;
            }
        }

        audioEditorUtils.addActionToHistory();
    },
    setTitleFocus() {
        var trackTitle = document.getElementsByClassName('trackTitle_' + this.props.trackIndex)[0];

        if (trackTitle) {
            trackTitle.removeAttribute('disabled');
            trackTitle.focus();
            trackTitle.setSelectionRange(0, 600);
        }
    },
    getProperties() {
        var prop;
        var timeline = this.getTimeline(this.props.trackIndex);

        switch(this.props.index) {
            case 0: {
                prop = {title: locales.getCaption('renameTrack', 'other'), icon: 'fa fa-pencil'};
                break;
            }
            case 1: {
                if (timeline.isSolo)
                    prop = {title: locales.getCaption('unsoloTrack', 'other'), icon: 'fa fa-certificate'};
                else
                    prop = {title: locales.getCaption('soloTrack', 'other'), icon: 'fa fa-certificate'};
                break;
            }
            case 2: {
                if (timeline.isMute)
                    prop = {title: locales.getCaption('unmuteTrack', 'other'), icon: 'fa fa-medium'};
                else
                    prop = {title: locales.getCaption('muteTrack', 'other'), icon: 'fa fa-medium'};
                break;
            }
            case 3: {
                prop = {title: locales.getCaption('addTrack', 'other'), icon: 'fa fa-plus'};
                break;
            }
            case 4: {
                prop = {title: locales.getCaption('deleteTrack', 'other'), icon: 'fa fa-trash-o'};
                break;
            }
        }

        return prop;
    },
    isDisabled() {
        if (this.props.index == 3) {
            var timelines = audioEditorUtils.getTimelinesLength();
            var maxTimelines = audioEditorUtils.getMaxTimelines();

            if (timelines >= maxTimelines)
                return true;
            else
                return false;
        } else
            return false;
    },
    render() {
        var buttonColor;
        var textColor;
        var opacity = 1;

        if (this.isDisabled()) {
            buttonColor = properties.SLIDE_MENU_COLOR;
            textColor = '#000000';
            opacity = 0.5;
        } else
        if (this.state.isOver == true) {
            buttonColor = properties.BROWSER_HOVER_COLOR;
            textColor = '#2299D6';
        } else {
            buttonColor = properties.SLIDE_MENU_COLOR;
            textColor = '#000000';
        }

        const tabStyle = {
            position: 'absolute',
            backgroundColor: buttonColor,
            width: properties.BUTTONS_HOLDER_WIDTH,
            height: properties.SLIDE_MENU_BUTTON_HEIGHT,
            top: properties.SLIDE_MENU_BUTTON_HEIGHT * this.props.index,
            color: 'white',
            userSelect: 'none',
            WebkitUserSelect: 'none',
            userDrag: 'none',
            opacity: opacity,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            borderStyle: 'none'
        };

        const spanStyle = {
            position: 'absolute',
            top: 12,
            left: 35,
            color: textColor,
            fontSize: 14,
            width: tabStyle.width - 40,
            height: 18,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default',
            textAlign: 'left'
        };

        const iconStyle = {
            position: 'absolute',
            top: 11,
            left: 10,
            color: textColor
        };

        var prop = this.getProperties();
        var iconElement;

        if (this.props.index == 1 || this.props.index == 2) {
            const letterStyle = {
                position: 'absolute',
                top: 12,
                left: 10,
                color: textColor,
                fontSize: 16,
                fontWeight: 'bold',
                width: 12,
                height: 18,
                cursor: 'default'
            };

            if (this.props.index == 2)
                iconElement = <span style={letterStyle}>{'M'}</span>;
            else
                iconElement = <span style={letterStyle}>{'S'}</span>;
        } else
            iconElement = <i style={iconStyle} className={prop.icon}></i>;

        var spanId = 'trackMenuButton_' + this.props.index;
        var buttonId = this.props.index == 0 ? 'audioTrackMenuButton' : undefined;

        return (
            <button id={buttonId} style={tabStyle} aria-labelledby={spanId} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onClick={this.onClick} onTouchEnd={this.onClick} onTouchStart={this.onTouchStart} onMouseDown={this.onTouchStart}>
                {iconElement}
                <span id={spanId} style={spanStyle}>{prop.title}</span>
            </button>
        );
    }
});

const AudioTrackMenuContent = React.createClass({
    componentDidMount() {
        document.addEventListener('click', this.onCloseMenu);
        document.addEventListener('touchend', this.onCloseMenu);
    },
    componentWillUnmount() {
        document.removeEventListener('click', this.onCloseMenu);
        document.removeEventListener('touchend', this.onCloseMenu);
    },
    componentWillReceiveProps(nextProps) {
        if (platformDetection.isIOS())
            return;

        if (this.props.index != nextProps.index && nextProps.index >= 0) {
            setTimeout(function() {
                var firstButton = document.getElementById('audioTrackMenuButton');

                if (firstButton)
                    firstButton.focus();
            }.bind(this), 10);
        }
    },
    onCloseMenu(e) {
        if (textSizeUtils.isTextEditMode())
            return;

        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (!platformDetection.isIOS()) {
            if (!document.getElementById('htmlColorPicker'))
                e.preventDefault();
        }

        const target = e.target;
        var type = typeof  target.className;

        if (type == 'string') {

            if (target.className.indexOf('trackSettings') != -1) { // it's settings button
            } else
                this.hideTrackMenu();
        } else
            this.hideTrackMenu();
    },
    hideTrackMenu() {
        const state = storeManager.getState();

        if (state.audioEditor.trackMenu != -1)
            this.props.dispatch(showTrackMenu(-1));
    },
    render() {
        if (this.props.index == -1)
            return (<div/>);

        var width = properties.BUTTONS_HOLDER_WIDTH;
        var height = 5 * properties.SLIDE_MENU_BUTTON_HEIGHT;
        var top = this.props.index * audioToolUtils.timelineHeight() - height;

        if (audioToolUtils.isAudioTool() && (this.props.index == 0 || this.props.index == 1 || this.props.index == 2))
            top = (this.props.index + 1) * audioToolUtils.timelineHeight();

        var menuStyle = {
            position: 'absolute',
            cursor: 'default',
            userSelect: 'none',
            WebkitUserSelect: 'none',
            top: top,
            left: 0,
            width,
            height,
            background: 'white'
        };

        return (
            <div style={menuStyle}>
                <Button index={0} trackIndex={this.props.index} dispatch={this.props.dispatch}/>
                <Button index={1} trackIndex={this.props.index} dispatch={this.props.dispatch}/>
                <Button index={2} trackIndex={this.props.index} dispatch={this.props.dispatch}/>
                <Button index={3} trackIndex={this.props.index} dispatch={this.props.dispatch}/>
                <Button index={4} trackIndex={this.props.index} dispatch={this.props.dispatch}/>
            </div>
        );
    }
});

function mapStateToProps(state) {
    var index = state.audioEditor.trackMenu;

    if (index == undefined)
        index = -1;

    return {
        index
    };
}

export const AudioTrackMenu = connect(mapStateToProps)(AudioTrackMenuContent);



/** WEBPACK FOOTER **
 ** ./src/components/audioEditor/menus/AudioTrackMenu.js
 **/